/**
 * Divisão de módulos do sistema.
 */
export enum ModuloSistema {
  Ferias = 1,
  Movimentacoes = 2,
  FolhaFrequencia = 3,
  RelatoriosAtividades = 4,
}

